// ── Modelo do domínio Webhooks (núcleo puro) ──────────────────────
// Contrato dos eventos de saída do CRM e da configuração por workspace.
// Espelha Config/87_workspace_webhooks.sql e a Edge Function
// supabase/functions/workspace-webhook.

export type WorkspaceWebhookEvent =
  | 'lead.created'
  | 'meeting.scheduled'
  | 'proposal.created'
  | 'sale.created';

export const WORKSPACE_WEBHOOK_EVENTS: WorkspaceWebhookEvent[] = [
  'lead.created',
  'meeting.scheduled',
  'proposal.created',
  'sale.created',
];

export const WORKSPACE_WEBHOOK_EVENT_LABELS: Record<WorkspaceWebhookEvent, string> = {
  'lead.created':      'Lead criado',
  'meeting.scheduled': 'Reunião agendada',
  'proposal.created':  'Proposta criada',
  'sale.created':      'Venda registrada',
};

export const WORKSPACE_WEBHOOK_EVENT_HINTS: Record<WorkspaceWebhookEvent, string> = {
  'lead.created':
    'Qualquer origem: modal do CRM, importação em massa e criação externa via API/n8n (disparado pelo banco).',
  'meeting.scheduled':
    'Ao confirmar o agendamento de uma reunião.',
  'proposal.created':
    'Ao salvar a proposta na aba Proposta OU ao mover o card para a etapa de proposta enviada.',
  'sale.created':
    'Ao registrar a venda no modal de venda.',
};

// Configuração persistida em public.workspace_webhooks (1 linha por workspace).
export interface WorkspaceWebhookConfig {
  workspaceId: string;
  enabled: boolean;
  url: string;
  // Só o servidor precisa do segredo para assinar; no painel ele é editável
  // mas nunca sai do escopo do owner da plataforma (RLS).
  secret: string;
  events: Record<WorkspaceWebhookEvent, boolean>;
  customHeaders: Record<string, string>;
  updatedAt?: string | null;
}

export type WorkspaceWebhookConfigInput = Omit<WorkspaceWebhookConfig, 'updatedAt'>;

// Registro de auditoria de public.webhook_deliveries.
export interface WebhookDelivery {
  id: string;
  workspaceId: string;
  event: string;
  dedupeKey: string | null;
  leadId: string | null;
  url: string | null;
  status: 'success' | 'failed';
  httpStatus: number | null;
  attempts: number;
  error: string | null;
  durationMs: number | null;
  createdAt: string;
}

export interface DispatchWebhookParams {
  event: WorkspaceWebhookEvent;
  workspaceId: string;
  leadId: string;
  // Chave de idempotência. Sem ela o mesmo evento pode ser entregue de novo:
  // lead_id para lead.created/proposal.created, meeting_id, sale_id.
  dedupeKey?: string | null;
  // Ids e metadados do bloco específico do evento. O payload em si é montado
  // no servidor a partir do banco — isto aqui não vira payload direto.
  data?: Record<string, unknown> | null;
}

export const defaultWebhookEvents = (): Record<WorkspaceWebhookEvent, boolean> =>
  WORKSPACE_WEBHOOK_EVENTS.reduce(
    (acc, event) => ({ ...acc, [event]: true }),
    {} as Record<WorkspaceWebhookEvent, boolean>,
  );

export const emptyWebhookConfig = (workspaceId: string): WorkspaceWebhookConfig => ({
  workspaceId,
  enabled: false,
  url: '',
  secret: '',
  events: defaultWebhookEvents(),
  customHeaders: {},
  updatedAt: null,
});
